import React from "react";
import { FaArrowRight, FaEnvelope, FaPhone } from "react-icons/fa";
import "./ContactInfo.css";

export const ContactInfo = ({ scrollToRef }) => {
  const contactEmail = "info@cubic.energy";

  const offices = [
    {
      location: "Portugal",
      flagCode: "pt",
      phone: "+351 933 425 475",
      phoneHref: "tel:+351933425475",
    },
    {
      location: "Dubai",
      flagCode: "ae",
      phone: "+971 56 900 7595",
      phoneHref: "tel:+971569007595",
    },
    {
      location: "Angola",
      flagCode: "ao",
      phone: "+244 944 178 538",
      phoneHref: "tel:+244944178538",
    },
  ];

  const handleEmailClick = () => {
    window.location.href = `mailto:${contactEmail}`;
  };

  const handleScrollToMessage = () => {
    if (scrollToRef && scrollToRef.current) {
      scrollToRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="contact-info-section">
      <div className="contact-info-container">
        <div className="contact-info-intro">
          <p className="contact-info-eyebrow">Fale com a Cubic</p>
          <h2>Vamos encontrar a melhor forma de apoiar o seu projeto.</h2>
          <p className="contact-info-lead">
            Partilhe connosco o âmbito, a localização e a fase de desenvolvimento.
            A nossa equipa entra em contacto para enquadrar a solução técnica mais adequada.
          </p>

          <div className="contact-primary-actions">
            <button type="button" className="contact-message-button" onClick={handleScrollToMessage}>
              Enviar mensagem
              <FaArrowRight />
            </button>

            <div className="contact-primary-list">
              <a className="contact-primary-item" href={`mailto:${contactEmail}`} onClick={handleEmailClick}>
                <FaEnvelope />
                <span>{contactEmail}</span>
              </a>
            </div>
          </div>
        </div>

        <div className="contact-locations-panel">
          <div className="contact-locations-header">
            <p className="contact-info-eyebrow">Presença internacional</p>
            <h3>Localizações em crescimento</h3>
            <p>
              Espaços reservados para os próximos contactos e mercados estratégicos da Cubic.
            </p>
          </div>

          <div className="contact-locations-grid">
            {offices.map((office) => (
              <article key={office.location} className="contact-location-card">
                <div className="contact-location-flag" aria-hidden="true">
                  <img
                    src={`https://flagcdn.com/w40/${office.flagCode}.png`}
                    srcSet={`https://flagcdn.com/w80/${office.flagCode}.png 2x`}
                    alt=""
                  />
                </div>
                <h4>{office.location}</h4>
                <a className="contact-location-phone" href={office.phoneHref}>
                  <FaPhone />
                  <span>{office.phone}</span>
                </a>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
